import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'stellenangeboteFilter',
    pure: false
})
export class StellenangeboteFilterPipe implements PipeTransform {

    customFilter = ['Initiativbewerbung', 'Praktikum', 'Ferienhelfer'];

    //
    transform(items: any, filter: any): any {
        if (items) {
            return items.filter(item => this.filter(item, filter));
        }
    }

    filter(item, filter) {
        let show = true;
        if (item.data.startdatum && item.data.enddatum) {
            const start = new Date(item.data.startdatum).getTime();
            const end = new Date(item.data.enddatum).getTime();
            const now = new Date().getTime();
            if (start > now || end < now) {
                return false;
            }

        } else {
            return false;
        }
        if (filter.spezialFilter.length > 0 && item.data.titel !== filter.spezialFilter) {
            show = false;
        } else {
            // Freitext Suche
            if (this.customFilter.includes(item.data.titel)) {
                show = false;
            }
            // dfreeitext
            if (filter.textFilter.length > 0 && ((item.description
                && item.description.toLowerCase().indexOf(filter.textFilter.toLowerCase()) === -1)
                && (item.data.titel && item.data.titel.toLowerCase().indexOf(filter.textFilter.toLowerCase()) === -1))) {
                show = false;
            }
            // Standort
            if (filter.standortFilter.length > 0) {
                if (filter.standortFilter === '100') {
                    if (['100', '110', '115'].indexOf(item.data.mandant) === -1) {
                        show = false;
                    }
                } else if (item.data.mandant !== filter.standortFilter) {
                    show = false;
                }
            }
            // Abteilung
            if (filter.abteilungFilter && filter.abteilungFilter.length > 0) {
                for (let i = 0; i <= item.data.abteilungen.length; i++) {
                    if (item.data.abteilungen.indexOf(filter.abteilungFilter) === -1) {
                        show = false;
                    }
                }
            }
            // Art
            if (filter.typeFilter.length > 0 && item.data.stellenart !== filter.typeFilter) {
                show = false;
            }
        }
        return show;
    }
}
